import React, { useState } from 'react';
import { ButtonTertiary, GroupPanel, Numberbox, ValidationProps } from 'ui';
import { ComplexValue, LoadOptions, RequestRemoteApi } from 'app/types-shared';
import * as navigate from 'app/area/shared/navigation';
import { SelectSingleHierarchy } from 'app/area/shared/translated-components';
import { SavedReportsTranslation, SavedReportsEndpoints, statisticalReport } from '../constants';
import { SavedReport } from '../types-store';

import styles from './saved-report-picker.scss';

export const manageOptionsButton = (label: string) => (onClose: () => void) => {
  const handleClick = () => {
    onClose();
    navigate.toSearchView(true);
  };

  return <ButtonTertiary onClick={handleClick}>
    {label}
  </ButtonTertiary>;
};

interface SavedReportFormProps {
  valueItem: ComplexValue<number>;
  displayMySavedReport: boolean;

  updateCurrent: (savedReport: Partial<SavedReport>) => void;

  endpoints: SavedReportsEndpoints;

  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    }
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;

  locale: string;
  validation: { [T in keyof SavedReport]?: ValidationProps };
  translation: SavedReportsTranslation;
}

const savedReport = 'savedReport';
const mySavedReportId = 'mySavedReportId';
const savedReportId = 'savedReportId';

export const SavedReportPicker: React.FC<SavedReportFormProps> = ({
  valueItem, displayMySavedReport, updateCurrent,
  endpoints, options, loadOptions,
  locale, validation, translation
}) => {

  const [mySavedReport, setMySavedReport] = useState(false);

  const [codeOptions, setCodeOptions] = useState<LoadOptions>();

  const onCodeLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(
      mySavedReportId,
      endpoints.savedReportsOptions,
      {
        ...loadOptionsParams,
        requestRemoteApi: RequestRemoteApi.servicesApi
      },
      {
        reportCategories: statisticalReport
      }
    );
    setCodeOptions(loadOptionsParams);
  };

  const onMySavedReportChange = (value: ComplexValue<number>) => {
    setMySavedReport(true);
    updateCurrent({ code: value });
  };

  const onSavedReportIdChange = (value: number) => {
    setMySavedReport(false);
    updateCurrent(value ? { code: { value } } : { code: undefined });
  };

  const reportIdComponent = <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId={savedReportId}
      label={translation ? { text: translation.saved_report_id, required: !displayMySavedReport } : undefined}
      info={displayMySavedReport && translation ? { text: translation.saved_report_info, visible: true } : undefined}
      value={!mySavedReport ? valueItem?.value : undefined}
      onChange={onSavedReportIdChange}
      useThousand=" "
      maxValue={999999999}
      locale={locale}
      validation={!mySavedReport ? validation?.code : undefined}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;

  return <>
    <div className={styles.hint}>{translation?.saved_report_hint}</div>
    {displayMySavedReport
      ? <GroupPanel componentId={savedReport}
        className={undefined}
        label={{ text: translation.saved_report, required: true }}>
        <div className="col-lg-6 col-sm-12">
          <SelectSingleHierarchy
            componentId={mySavedReportId}
            className={undefined}
            label={translation ? { text: translation.my_saved_report } : undefined}
            info={translation ? { text: translation.saved_report_info, visible: true } : undefined}
            valueItem={mySavedReport ? valueItem : undefined}
            onChange={onMySavedReportChange}
            leafNodeOnly={true}
            validation={mySavedReport ? validation?.code : undefined}

            options={options?.[mySavedReportId]?.codes as ComplexValue<number>[] || []}
            fetching={options?.[mySavedReportId]?.fetching || false}
            loadOptions={codeOptions}
            onLoadOptions={onCodeLoadOptions}

            placeholder={translation?.search}
            extraFooterButton={manageOptionsButton(translation.add_new_report)} />
        </div>
        {reportIdComponent}
      </GroupPanel>
      : <div className="row">{reportIdComponent}</div>
    }
  </>;
};
